"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onInitialClientRender = exports.wrapRootElement = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _createStore = _interopRequireDefault(require("./.tmp/createStore"));

var _constants = require("./constants");

var wrapRootElement = function wrapRootElement(_ref, pluginOptions) {
  var element = _ref.element;

  if (pluginOptions === void 0) {
    pluginOptions = {};
  }

  var options = (0, _extends2["default"])({}, _constants.DEFAULT_OPTIONS, {}, pluginOptions);
  var preloadedState = window[options.windowKey];
  var store = (0, _createStore["default"])(preloadedState);
  return _react["default"].createElement(_reactRedux.Provider, {
    store: store
  }, element);
};

exports.wrapRootElement = wrapRootElement;

var onInitialClientRender = function onInitialClientRender(_, pluginOptions) {
  if (pluginOptions === void 0) {
    pluginOptions = {};
  }

  var options = (0, _extends2["default"])({}, _constants.DEFAULT_OPTIONS, {}, pluginOptions);
  if (process.env.BUILD_STAGE !== 'build-javascript') return;
  if (!options.cleanupOnClient) return;
  delete window[options.windowKey];
  var preloadedStateEl = document.getElementById(_constants.SCRIPT_ELEMENT_ID);

  if (preloadedStateEl) {
    preloadedStateEl.parentNode.removeChild(preloadedStateEl);
  }
};

exports.onInitialClientRender = onInitialClientRender;